import { useEffect, useState } from "react";
import { GET_ACCOUNTANTS, GET_ADMINS, GET_CLIENT_CONTACT_BY_USER } from "../../../api/apiAdmin";
import { getRegimen } from "../../../data/regimenFiscalData";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";

const InfoEmpresa = ({ empresa }) => {
  const [admins, setAdmins] = useState([]);
  const [client, setClient] = useState();
  const [accountants, setAccountants] = useState([]);
  const [responsable, setResponsable] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);

      try {
        const accountantsData = await GET_ACCOUNTANTS();
        setAccountants(accountantsData);
      } catch (error) {
        console.error("Error al obtener contadores:", error);
      }

      try {
        const adminsData = await GET_ADMINS();
        setAdmins(adminsData);
      } catch (errorAdmins) {
        console.error("Error al obtener admins:", errorAdmins);
      }

      try {
        const clientData = await GET_CLIENT_CONTACT_BY_USER(empresa?.userId);
        setClient(clientData);
      } catch (errorAdmins) {
        console.error("Error al obtener admins:", errorAdmins);
      }

      setLoading(false);
    };

    getData();
  }, [empresa]);

  useEffect(() => {
    if (!empresa) return;

    let found = null;

    if (empresa.adminId && admins?.length > 0) {
      found = admins.find((a) => a.id === empresa.adminId);
    } else if (empresa.accountantId && accountants?.length > 0) {
      found = accountants.find((c) => c.id === empresa.accountantId);
    }

    setResponsable(found || null);
  }, [empresa, admins, accountants]);

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    toast.success("Copiado al portapapeles ✅", { autoClose: 1000 });
  };

  const Field = ({ label, value }) => (
    <div className="col-span-2 md:col-span-1 block md:flex w-full cursor-pointer" onClick={() => copyToClipboard(value)}>
      <strong className="block md:flex">{label}: </strong>
      <span className="block md:flex text-blue-600 hover:underline break-words">&nbsp;{value || "-"}</span>
    </div>
  );

  if (loading)
    return (
      <div className="h-[20vh] w-full flex justify-center items-center">
        <PropagateLoader color="red" />
      </div>
    );

  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-2">
      <Field label="Nombre" value={empresa?.name} />
      <Field label="RFC" value={empresa?.rfc} />
      <Field label="Regimen" value={getRegimen(empresa?.c_RegimenFiscal)} />
      <Field label="Dirección" value={empresa?.address} />
      <Field label="Teléfono" value={empresa?.cellphone} />
      <Field label="Correo" value={empresa?.email_client} />
      <Field label="R. Legal" value={empresa?.name_rl} />
      <Field label="RFC R.L." value={empresa?.rfc_rl} />
      <Field label="Cliente" value={client?.name} />
      <Field label="Correo del cliente" value={client?.user?.email} />

      {responsable && (
        <>
          <p className="col-span-2 mt-4 font-semibold">Responsable:</p>
          <Field label="Nombre" value={responsable?.name} />
          <Field label="Teléfono" value={responsable?.cellphone} />
          <Field label="Email" value={responsable?.user?.email} />
        </>
      )}
    </div>
  );
};

export default InfoEmpresa;
